import { AvnuSwapTransactionHistoryItem } from '../../interfaces/AvnuSwapTransactionHistoryItem';
import { walletAddressAtom } from '../wallet';
import storage from '../../storage';
import { createAsyncAtom } from '../../lib/state';

const avnuSwapTransactionHistoryAtom = createAsyncAtom<AvnuSwapTransactionHistoryItem[]>(
  async get => {
    const walletAddress = await get(walletAddressAtom);
    if (!walletAddress) {
      return null;
    }

    try {
      const data = await storage.getAvnuSwapTransactionHistory(walletAddress);
      if (!data) {
        return null;
      }

      return data.map(doc => {
        return {
          hash: doc.id,
          account: doc.account,
          buyAddress: doc.buyAddress,
          buyAmount: doc.buyAmount,
          sellAddress: doc.sellAddress,
          sellAmount: doc.sellAmount,
          timestamp: doc.timestamp * 1000,
        };
      });
    } catch (e) {
      console.error('avnuSwapTransactionHistory - Failed to get avnu swap transaction history', e);
      return null;
    }
  },
  undefined,
  ['user-refresh'],
);
export default avnuSwapTransactionHistoryAtom;
